import { render, staticRenderFns } from "./JettonAddressRows.vue?vue&type=template&id=eb54f2c4"
import script from "./JettonAddressRows.vue?vue&type=script&lang=js"
export * from "./JettonAddressRows.vue?vue&type=script&lang=js"
import style0 from "./JettonAddressRows.vue?vue&type=style&index=0&id=eb54f2c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports